import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button
} from '@mui/material';
import {
  ArrowBack,
  Language
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import EnhancedWebsiteAnalyzer from '../components/WebsiteAnalysis/EnhancedWebsiteAnalyzer';
import { EnhancedWebsiteInsights } from '../services/websiteAPI';

export const WebsiteAnalysisPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGenerateContent = (insights: EnhancedWebsiteInsights) => {
    // Navigate to create post page with insights
    navigate('/create-post', {
      state: {
        insights,
        mode: 'website-insights'
      }
    });
  };

  const handleAnalysisComplete = (insights: EnhancedWebsiteInsights) => {
    console.log('Analysis completed:', insights);
    // You can add additional logic here, like saving to state or analytics
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            Back to Dashboard
          </Button>
          <Language color="primary" sx={{ mr: 2, fontSize: 32 }} />
          <Typography variant="h4" component="h1">
            Website Analysis
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Analyze websites using our enhanced MCP-powered system to extract comprehensive insights and generate targeted LinkedIn content
        </Typography>
      </Box>

      {/* Enhanced Website Analyzer Component */}
      <EnhancedWebsiteAnalyzer
        onGenerateContent={handleGenerateContent}
        onAnalysisComplete={handleAnalysisComplete}
      />
    </Container>
  );
};

export default WebsiteAnalysisPage; 